import {
  HelperResult,
  ProfessionalStatus,
  ProfessionalStatusMutationBody,
} from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useGetProfessionalStatus,
  useUpdate: useUpdateProfessionalStatus,
  useDelete: useDeleteProfessionalStatus,
} = getCRUDHooks({
  entityName: 'professionalStatus',

  get: ({ userId }: { userId: number }): HelperResult<ProfessionalStatus> =>
    clientApi.getOCClient().helpers.user.users.id(userId).professionalStatus.get(),

  update: (
    body: ProfessionalStatusMutationBody,
    { userId, context }: { userId: number; context: string }
  ): HelperResult<ProfessionalStatus> =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .professionalStatus.update('', body, false)
      .setHeader('X-Request-Context', context)
      .execute(),

  remove: ({ userId }: { userId: number }): HelperResult<void> =>
    clientApi.getOCClient().helpers.user.users.id(userId).professionalStatus.delete(),
});

export { useGetProfessionalStatus, useUpdateProfessionalStatus, useDeleteProfessionalStatus };
